import { NewTable, Table, Input } from '@carta/ink';
import * as React from 'react';
export default {
  NewTable,
  Table,
  Input,
  React
};